import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ClinicalIndustry from "@/pages/ClinicalIndustry";

export const Route = createFileRoute("/en/services/full-service-medical-device-cro")({
  head: () => buildRouteHead("/en/services/full-service-medical-device-cro", {
      title: "Full-Service Medical Device CRO | QbD Group",
      description: "A full-service medical device CRO covering clinical strategy, study operations, monitoring, data management and regulatory reporting under MDR and IVDR.",
    }),
  component: ClinicalIndustry,
});

